import { Button } from 'antd';
import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: 12px;
`;

export const FlashcardActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ActionsButtonsWrapper = styled.div`
  display: flex;
  align-items: left;
  gap: 5px;
  flex-direction: column;
`;

export const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  border: none;
  box-shadow: none;
  & > * {
    width: 100%;
    text-align: left;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  width: 100%;
`;
